import React from 'react';

import DatePicker from 'react-datepicker';

import moment from 'moment';

class DatabaseUpload extends React.Component {
  state = {
    all: true,
    start: moment().subtract(1, 'year').startOf('day'),
    end: moment().endOf('day'),
  };

  setAll = (all) => {
    this.setState({all});
  };

  setEnd = (end) => {
    this.setState({end});
  };

  setStart = (start) => {
    this.setState({start});
  };

  all = () => {
    return this.state.all;
  };

  end = () => {
    return this.all() ? null : this.state.end;
  };

  start = () => {
    return this.all() ? null : this.state.start;
  };

  toggleAll = () => {
    this.setAll(!this.all());
  };

  render() {
    const {all, start, end} = this.state;

    return (
      <div>
        <p>
          <span className='checkbox-wrapper'>
            <input type='checkbox' checked={all}
              onChange={(e) => this.setAll(e.target.checked)} />
            <label/>
          </span>

          <span className='pointer' onClick={this.toggleAll}>
            All analyses
          </span>
        </p>

        <div className='row'>
          <div className='col-sm-6' onClick={() => this.setAll(false)}>
            <strong>Created From:</strong><br />
            <DatePicker
              disabled={all}
              selected={all ? null : start}
              className='form-control'
              onChange={this.setStart} />
          </div>

          <div className='col-sm-6' onClick={() => this.setAll(false)}>
            <strong>To:</strong><br />
            <DatePicker
              disabled={all}
              selected={all ? null : end}
              className='form-control'
              onChange={this.setEnd} />
          </div>
        </div>
      </div>
    );
  }
}

export default DatabaseUpload;
